<template>
  <div class="login">
    <div class="content">
      <div class="title">
        Вход
      </div>
      <div class="inputBlock" v-for="(input, key) in auth" :key="key">
        <Ui :data="input" @set="setForm({ key: key, value: $event })" />
      </div>
      <div class="btn">
        <Button
          class="mr"
          label="Войти"
          @click="login"
          :disabled="!getValidLogin"
        />
      </div>
      <div class="error animate__animated animate__bounceIn" v-if="authError">
        {{ authError }}
      </div>
    </div>
  </div>
</template>

<script>
import Ui from "@/components/Ui";
import Button from "@/components/ui/Button";

import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    Ui,
    Button,
  },
  computed: {
    ...mapState(["auth", "authError"]),
    ...mapGetters(["getValidLogin"]),
  },
  methods: {
    ...mapActions(["login", "setForm", "setAuthError"]),
  },
  mounted() {
    // Clear any previous auth errors when component is mounted
    this.setAuthError(null);
  },
};
</script>

<style lang="scss" scoped>
.login {
  @include box(100%, 100%, absolute, 0, 0, null, null, 0, null);
  @include flex(center, center, row);
  .content {
    @include box(25%, auto, relative, 0, 0, null, null, 0.6vw, null);
    @include border(0.1vw, solid, $contentBorder, null, null, null, null);
    @include padding(3vw, 2vw, 3vw, 2vw);
    .title {
      @include box(100%, auto, relative, null, null, null, null, null, null);
      @include text(2.2vw, 400, null, null, center, $text);
    }
    .inputBlock {
      @include box(100%, null, relative, null, null, null, null, null, null);
      @include margin(0, 1vw, 0, 0);
    }
    .btn {
      @include size(100%, null);
      @include flex(center, center, row);
      @include padding(0, 2vw, 0, 0);
      .button {
        @include size(60%, null);
      }
    }
    .error {
      @include box(
        100%,
        auto,
        relative,
        null,
        null,
        null,
        null,
        0.4vw,
        $contentError
      );
      @include text(0.9vw, 400, null, null, center, $contentErrorColor);
      @include padding(1vw, 0.6vw, 1vw, 0.6vw);
      @include margin(0, 2vw, 0, 0);
    }
  }
}
</style>
